export default __webpack_public_path__ + "vLvaEA3-dashboard.svg";